import bg from '../assets/assets/bg.png';
import chef from '../assets/assets/chef.png';
import G from '../assets/assets/G.png';
import gallery01 from '../assets/assets/gallery01.png';
import gallery02 from '../assets/assets/gallery02.png';
import gallery03 from '../assets/assets/gallery03.png';
import gallery04 from '../assets/assets/gallery04.png';
import knife from '../assets/assets/knife.png';
import logo from '../assets/assets/logo.png';
import menu from '../assets/assets/menu.png';
import overlaybg from '../assets/assets/overlaybg.png';
import spoon from '../assets/assets/spoon.svg';
import welcome from '../assets/assets/welcome.png';
import findus from '../assets/assets/findus.png';
import laurels from '../assets/assets/laurels.png';
import award01 from '../assets/assets/award01.png';
import award02 from '../assets/assets/award02.png';
import award03 from '../assets/assets/award03.png';
import award05 from '../assets/assets/award05.png';
import sign from '../assets/assets/sign.png';
import quote from '../assets/assets/quote.png';
import gericht from '../assets/assets/gericht.png';

export default {
  bg,
  chef,
  G,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  knife,
  logo,
  menu,
  overlaybg,
  spoon,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  quote,
  gericht,
};
